import api from "../../api";
import { AUTH_URL } from "@/const";
// import * as util from "@/utils";
import router from "@/router";

const state = {
  token: "",
  status: "",
  hasLoadedOnce: false,
  dueAt: "",
  rememberMe: false
};

const getters = {
  isAuthenticated: () =>
    !!localStorage.getItem("_token") || !!sessionStorage.getItem("_token")
};

const actions = {
  login: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit("login");
      commit("setSplashScreen", true, { root: true });
      // INFO: axios
      api
        .post(AUTH_URL, user, { timeout: 10000 })
        .then((resp) => {
          const data = resp.data;
          localStorage.setItem("_token", data.token);
          commit("success", data);
          commit("rememberMe", true);

          /* if (user.remember_me) {
            localStorage.setItem("_token", data.token);
            commit("success", data);
            commit("rememberMe", true);
          } else {
            util.session("_token", data.token);
            commit("success", data);
            commit("rememberMe", false);
          } */
          api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
          resolve(resp);
        })
        .catch((error) => {
          localStorage.removeItem("_token");
          sessionStorage.removeItem("_token");
          commit("setSplashScreen", false, { root: true });
          commit("error", error);
          reject(error);
        });
    });
  },
  logout: ({ commit }) => {
    return new Promise((resolve) => {
      commit("logout");
      localStorage.removeItem("_token");
      sessionStorage.removeItem("_token");
      delete api.defaults.headers.common["Authorization"];
      resolve(router.push("/login"));
    });
  }
};

const mutations = {
  login: (state) => {
    state.status = "loading";
  },
  success: (state, data) => {
    state.status = "success";
    state.token = data.token;
    state.hasLoadedOnce = true;
    state.dueAt = data.DueAt;
  },
  error: (state) => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  logout: (state) => {
    state.token = "";
  },
  rememberMe: (state, r) => {
    state.rememberMe = r;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
